/**
 * Created by Tw93 on 2017/10/21.
 */

export const CHECKED = '//gw.alicdn.com/tfs/TB14fp2pwMPMeJjy1XbXXcwxVXa-72-72.png';
export const UNCHECKED = '//gw.alicdn.com/tfs/TB1U6SbpwMPMeJjy1XcXXXpppXa-72-72.png';
export const CHECKED_DISABLED = '//gw.alicdn.com/tfs/TB1aPabpwMPMeJjy1XcXXXpppXa-72-72.png';
export const UNCHECKED_DISABLED = '//gw.alicdn.com/tfs/TB1lTuzpwoQMeJjy0FoXXcShVXa-72-72.png';



// WEBPACK FOOTER //
// ./packages/wxc-checkbox/type.js